/**
 * Main product grid gallery:
 * - Desktop: "Show more" reveals next 4 images in the grid per click.
 * - Mobile: carousel pagination sync + zoom chip opens lightbox for active slide.
 */
(function () {
  const BATCH_SIZE = 4;

  function initShowMore() {
    const moreContainer = document.querySelector('[data-product-media-grid-more]');
    const showMoreWrap = document.querySelector('[data-product-media-grid-show-more-wrap]');
    const showMoreBtn = document.querySelector('[data-product-media-grid-show-more]');

    if (!moreContainer || !showMoreBtn || !showMoreWrap) return;

    const items = moreContainer.querySelectorAll('.product-media-grid__item');
    if (items.length === 0) {
      showMoreWrap.classList.add('is-hidden');
      return;
    }

    let revealed = 0;

    showMoreBtn.addEventListener('click', function () {
      moreContainer.classList.add('is-visible');

      const toReveal = Math.min(BATCH_SIZE, items.length - revealed);
      for (let i = 0; i < toReveal && revealed + i < items.length; i++) {
        items[revealed + i].classList.add('is-revealed');
      }
      revealed += toReveal;

      if (revealed >= items.length) {
        showMoreWrap.classList.add('is-hidden');
      }
    });
  }

  function getActiveSlideIndex(carousel, slides) {
    const scrollLeft = carousel.scrollLeft;
    let activeIndex = 0;
    let minDist = Infinity;

    slides.forEach(function (slide, index) {
      const dist = Math.abs(slide.offsetLeft - scrollLeft);
      if (dist < minDist) {
        minDist = dist;
        activeIndex = index;
      }
    });

    return activeIndex;
  }

  function isImageSlide(slide) {
    return slide && slide.querySelector('.media-type-image');
  }

  function initMobileCarousel() {
    document.querySelectorAll('[data-grid-mobile-controls]').forEach(function (wrap) {
      const carousel = wrap.querySelector('[data-grid-mobile-carousel]');
      if (!carousel) return;

      const mobileRoot = wrap.closest('.product-media-grid__mobile');
      const slides = carousel.querySelectorAll('.product-media-grid__slide');
      const zoomChip = wrap.querySelector('[data-grid-mobile-zoom-chip]');
      const pagination = mobileRoot
        ? mobileRoot.querySelector('[data-grid-mobile-pagination]')
        : null;
      const dotLinks = pagination
        ? pagination.querySelectorAll('[data-grid-mobile-dot]')
        : [];
      const prevArrow = wrap.querySelector('[data-grid-mobile-arrow="prev"]');
      const nextArrow = wrap.querySelector('[data-grid-mobile-arrow="next"]');
      const total = slides.length;

      if (total === 0) return;

      let scrollRaf = null;

      function updateUI() {
        const index = getActiveSlideIndex(carousel, slides);
        const slideNum = index + 1;
        const activeSlide = slides[index];

        dotLinks.forEach(function (link) {
          const dotIndex = parseInt(link.getAttribute('data-grid-mobile-dot'), 10);
          const isActive = dotIndex === index;
          link.classList.toggle('slider-counter__link--active', isActive);
          if (isActive) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });

        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === index);
        });

        if (prevArrow) {
          if (index <= 0) {
            prevArrow.setAttribute('disabled', '');
          } else {
            prevArrow.removeAttribute('disabled');
          }
        }

        if (nextArrow) {
          if (index >= total - 1) {
            nextArrow.setAttribute('disabled', '');
          } else {
            nextArrow.removeAttribute('disabled');
          }
        }

        if (zoomChip) {
          const showChip = isImageSlide(activeSlide);
          zoomChip.hidden = !showChip;
          if (showChip && zoomChip.dataset.ariaLabelTemplate) {
            zoomChip.setAttribute(
              'aria-label',
              zoomChip.dataset.ariaLabelTemplate.replace('[index]', String(slideNum))
            );
          }
        }
      }

      function onScroll() {
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        scrollRaf = requestAnimationFrame(updateUI);
      }

      carousel.addEventListener('scroll', onScroll, { passive: true });
      if ('onscrollend' in window) {
        carousel.addEventListener('scrollend', updateUI);
      }

      dotLinks.forEach(function (link) {
        link.addEventListener('click', function () {
          const dotIndex = parseInt(link.getAttribute('data-grid-mobile-dot'), 10);
          const slide = slides[dotIndex];
          if (!slide) return;
          carousel.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
      });

      function goToOffset(delta) {
        const currentIndex = getActiveSlideIndex(carousel, slides);
        let target = currentIndex + delta;
        if (target < 0) target = 0;
        if (target > total - 1) target = total - 1;
        const slide = slides[target];
        if (!slide) return;
        carousel.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }

      if (prevArrow) {
        prevArrow.addEventListener('click', function () {
          goToOffset(-1);
        });
      }

      if (nextArrow) {
        nextArrow.addEventListener('click', function () {
          goToOffset(1);
        });
      }

      if (zoomChip) {
        zoomChip.addEventListener('click', function () {
          const index = getActiveSlideIndex(carousel, slides);
          const activeSlide = slides[index];
          if (!activeSlide) return;

          const toggle = activeSlide.querySelector('.product__media-toggle');
          if (toggle) toggle.click();
        });
      }

      updateUI();
    });
  }

  function init() {
    initShowMore();
    initMobileCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
